<template>
  <main-layout :selectedMenu="'home'">
    <section class="perfect-user-info userInfo">
      <h4>{{ $t("global.请先完善个人资料") }}</h4>
      <el-form
        :model="form"
        :rules="rules"
        ref="userForm"
        label-position="left"
      >
        <el-form-item
          :label="$t('global.头像')"
          :label-width="formLabelWidth"
          prop="avatar"
          class="avatar_1"
        >
          <cropImg
            style="position: absolute; left: -10000px"
            ref="cropComponent"
            :dialog-width="300"
            :dialog-height="300"
            :crop-width="180"
            :crop-height="180"
            :min-width="180"
            :min-height="180"
            :showtext="false"
            @update-img="updateImage"
            :is-upload="!form.avatar || isUpload"
          ></cropImg>
          <img
            class="avator-image"
            v-if="form.avatar"
            :src="
              form.avatar
                | imageUrl('/static/profile_img_default.png', 180, 180)
            "
          />
          <span @click="uploadAvator" v-else class="avator-image"></span>
        </el-form-item>
        <el-form-item
          :label="$t('global.性别')"
          :label-width="formLabelWidth1"
          prop="gender"
          class="gender2"
        >
          <input
            type="radio"
            name="sex"
            id="mansex"
            :checked="form.gender == '1'"
            @click="form.gender = 1"
          />
          <label for="mansex">{{ $t("global.男") }}</label>
          <input
            type="radio"
            name="sex"
            id="womensex"
            :checked="form.gender == '2'"
            @click="form.gender = 2"
          />
          <label for="womensex">{{ $t("global.女") }}</label>
        </el-form-item>
        <el-form-item
          :label="$t('global.所在地')"
          :label-width="formLabelWidth"
          prop="country"
        >
          <el-form-item prop="country" class="country">
            <el-select
              v-model="form.country"
              @change="resetArea"
              filterable
              :placeholder="$t('project.请搜索或选择国家')"
            >
              <el-option
                :label="language === 'zh' ? item.zh : item.en"
                :value="item.id"
                v-for="item in countryOptions"
                :key="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="area" class="area">
            <el-select
              v-model="form.area"
              filterable
              :placeholder="$t('global.请选择城市')"
            >
              <el-option
                :label="language === 'zh' ? item.zh : item.en"
                :value="item.id"
                v-for="item in cityOptions"
                :key="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form-item>
        <el-form-item
          :label="$t('global.手机号')"
          :label-width="formLabelWidth"
          prop="phone"
          class="avatar_1"
          v-if="language === 'zh'"
        >
          <p v-if="form.phone" class="hasPhone">
            <span>{{ form.phone }}</span>
          </p>
          <router-link to="/manageCenter?step=1" v-else>{{
            $t("global.绑定手机号")
          }}</router-link>
        </el-form-item>
        <el-form-item
          :label="$t('global.邮箱')"
          :label-width="formLabelWidth1"
          prop="email"
          class="gender1"
        >
          <p v-if="form.phone" class="hasPhone"></p>
          <p v-if="form.email" class="hasPhone">
            <span>{{ form.email }}</span>
          </p>
          <router-link to="/manageCenter?step=1" v-else>{{
            $t("global.去绑定")
          }}</router-link>
        </el-form-item>
        <!-- <el-form-item :label="$t('global.个性签名')" :label-width="formLabelWidth" prop="signature">
          <el-input
            v-model="form.signature"
            type="textarea"
            auto-complete="off"
            maxlength="100"
            show-word-limit
            :placeholder="$t('global.请填写个性签名')"
          ></el-input>
        </el-form-item>-->
        <el-form-item
          :label="$t('global.个人简介')"
          :label-width="formLabelWidth"
          prop="introduce"
        >
          <el-input
            v-model="form.introduce"
            type="textarea"
            auto-complete="off"
            maxlength="2000"
            show-word-limit
            class="personalProfile"
            :placeholder="$t('global.请填写个人简介')"
          ></el-input>
        </el-form-item>
        <el-form-item
          :label="$t('global.创作领域')"
          :label-width="formLabelWidth"
          prop="field"
        >
          <div class="userstyle1">
            <span
              v-for="(item, index) in fieldList"
              @click="changeEquipmentIds(item)"
              :class="{ active: isSelectOne(item, form.field) }"
              :key="index"
              >{{ item }}</span
            >

            <a class="clickaddtitle1" @click="addEquipment = true">{{
              $t("video.+新增")
            }}</a>
            <template v-if="addEquipment">
              <div class="userinfortit1">
                <input
                  type="text"
                  v-model="newEquipment"
                  maxlength="30"
                  :placeholder="$t('global.输入标签')"
                />
                <a @click="saveIndustry()">{{ $t("global.确定") }}</a>
              </div>
            </template>
          </div>
        </el-form-item>
      </el-form>
      <p @click="submit" class="userinfoSubmit">{{ $t("global.提 交") }}</p>
    </section>
  </main-layout>
</template>

<script>
import cropImg from "@/components/CropImg.vue";
import MainLayout from "@/layouts/MainLayout";
import * as qiniu from "qiniu-js";
export default {
  metaInfo() {
    return {
      title: this.$t("global.完善资料") + " | MANA",
    };
  },
  data() {
    return {
      form: {
        avatar: "",
        gender: 1,
        phone: "",
        email: "",
        introduce: "",
        country: "",
        area: "",
        field: [],
      },
      isUpload: false,
      rules: {
        avatar: [
          {
            required: true,
            message: this.$t("global.请上传头像"),
            trigger: "blur",
          },
        ],
        gender: [
          {
            required: true,
            message: this.$t("global.请选择性别"),
            trigger: "blur",
          },
        ],
        country: [
          {
            required: true,
            message: this.$t("global.请选择所在地"),
            trigger: "blur",
          },
        ],
        // area: [
        //   {
        //     required: true,
        //     message: this.$t("global.请选择城市"),
        //     trigger: "blur"
        //   }
        // ],
        field: [
          {
            required: true,
            message: this.$t("global.请选择创作领域"),
            trigger: "blur",
          },
        ],
        phone: [
          {
            required: true,
            message: this.$t("global.请先绑定手机号"),
          },
        ],
        email: [
          {
            required: true,
            message: this.$t("global.请先绑定邮箱"),
          },
        ],
        introduce: [
          {
            required: true,
            message: this.$t("global.请输入个人简介"),
            trigger: "blur",
          },
          {
            max: 2000,
            message: this.$t("global.最多输入2000个字符"),
            trigger: "blur",
          },
        ],
        // ,
        // signature: [
        //   {
        //     required: true,
        //     message: this.$t("global.请输入个性签名"),
        //     trigger: "blur"
        //   },
        //   {
        //     max: 100,
        //     message: this.$t("global.最多输入100个字符"),
        //     trigger: "blur"
        //   }
        // ]
      },
      formLabelWidth: "160px",
      formLabelWidth1: "40px",
      countryOptions: [],
      cityOptions: [],
      fieldList: [],
      addEquipment: false,
      newEquipment: "",
    };
  },
  props: ["close"],
  components: {
    cropImg,
    MainLayout,
  },
  watch: {
    "form.country"(value) {
      if (value || value === 0) {
        this.getCity(value);
      }
    },
    peopleMessage() {
      this.form = {
        avatar: this.peopleMessage.avatar,
        phone: this.peopleMessage.phone,
        email: this.peopleMessage.email,
        introduce: this.peopleMessage.introduce,
        country: +this.peopleMessage.country,
        area: this.peopleMessage.area ? +this.peopleMessage.area : "",
        gender: this.peopleMessage.gender,
        field: this.peopleMessage.field
          .split(",")
          .filter((item) => item && item.trim() != ""),
        // signature: this.peopleMessage.signature
      };
    },
  },
  created() {
    this.init();
  },
  computed: {
    peopleMessage() {
      return this.$store.state.peopleMessage;
    },
    language() {
      return this.$language();
    },
  },
  methods: {
    resetArea() {
      this.form.area = "";
    },
    init() {
      this.getFieldList();
      this.getInfo();
      this.getCountry();
      this.form = {
        avatar: this.peopleMessage.avatar,
        phone: this.peopleMessage.phone,
        email: this.peopleMessage.email,
        introduce: this.peopleMessage.introduce,
        country: +this.peopleMessage.country,
        area: +this.peopleMessage.area,
        gender: this.peopleMessage.gender,
        field: this.peopleMessage.field
          .split(",")
          .filter((item) => item && item.trim() != ""),
        // signature: this.peopleMessage.signature
      };
    },
    getFieldList() {
      this.$http.get("/api/mobile/u/fieldList").then((res) => {
        if (res.code === "OK") {
          this.fieldList = [
            ...new Set([
              ...this.fieldList,
              ...res.data.map((item) =>
                this.language === "zh" ? item.title : item.titleEn
              ),
            ]),
          ];
        }
      });
    },
    getInfo() {
      this.$http.get("/api/u/info/get").then((response) => {
        if (response.code === "OK") {
          this.$store.dispatch("setPeopleMessage", response.data);
          const field = response.data.field
            .split(",")
            .filter((item) => item && item.trim() != "");
          this.fieldList = [...new Set([...this.fieldList, ...field])];
        }
      });
    },
    isSelectOne(item, list) {
      let index = list.indexOf(item);
      if (index != -1) {
        return true;
      } else {
        return false;
      }
    },
    changeEquipmentIds(id) {
      let index = this.form.field.indexOf(id);
      if (index == -1) {
        this.form.field.push(id);
      } else {
        this.form.field.splice(index, 1);
      }
    },
    uploadAvator() {
      this.$refs.cropComponent.reUpload("3size");
    },
    updateImage(img) {
      let $this = this;
      const imgUrl = img.data;
      let imgFile = this.$jsonUtils.base64ToFile(imgUrl, "a.png");
      //上传截取图片
      // if (imgFile.size / 1024 / 1024 > 3) {
      //   this.$message.error(`${this.$t("global.上传图片大小不能超过")} 3MB!`);
      //   return;
      // }
      var observable;
      var subscription;
      var error = function (err) {
        $this.uploadMessage = $this.$t("global.上传失败");
      };
      var complete = function (res) {
        $this.uploadMessage = $this.$t("global.上传成功");
        $this.modifyAvatar(res.key);
      };

      var next = function (response) {};

      var subObject = {
        next: next,
        error: error,
        complete: complete,
      };

      var config = {
        useCdnDomain: true,
        region: null,
        domain: "https://image.manamana.net",
        forceDirect: true,
      };
      var putExtra = {
        fname: imgFile.name,
        params: {},
        mimeType: null,
      };
      this.$http.get("/api/common/upload/image/token").then((res) => {
        observable = qiniu.upload(
          imgFile,
          Date.parse(new Date()) + "_" + this.$jsonUtils.randomLetter(8),
          res.message,
          putExtra,
          config
        );
        subscription = observable.subscribe(subObject);
      });
      // let param = new FormData();
      // param.append("files", imgFile);
      // param.append("fileNames", "avatar");
      // // param.append("deleteNames", this.form.avatar);

      // this.$http
      //   .post("/api/common/upload/images", param, {
      //     headers: {
      //       "Content-Type": "multipart/form-data",
      //     },
      //   })
      //   .then((response) => {
      //     if (response.code === "OK") {
      //       this.modifyAvatar(response.data.avatar.key);
      //     } else {
      //       this.$message({
      //         message: response.message,
      //         type: "error",
      //       });
      //     }
      //   });
    },
    modifyAvatar(avatar) {
      this.$http
        .post("/api/u/changeAvatar", {
          avatar: avatar,
        })
        .then((response) => {
          this.$message({
            message: response.message,
            type: "success",
          });
          this.form.avatar = avatar;
          this.$store.dispatch("setPeopleMessage", {
            ...this.$store.state.peopleMessage,
            avatar,
          });
        });
    },
    getCountry() {
      this.$http.get("/api/mobile/area/getCountry").then((res) => {
        if (res.code === "OK") {
          const data = res.data;
          Object.keys(data).map((item) => {
            this.countryOptions = [...this.countryOptions, ...data[item]];
          });
          if (this.language === "zh") {
            this.countryOptions.unshift({
              city: [],
              en: "China",
              id: 0,
              py: "People's Republic of China",
              pyf: "P",
              value: "",
              zh: "中国",
            });
          }
        }
      });
    },
    getCity(id) {
      this.$http
        .get(`/api/mobile/area/getCityByCountryId?countryId=${id}`)
        .then((res) => {
          if (res.code === "OK") {
            this.cityOptions = res.data;
          }
        });
    },
    saveIndustry(type) {
      if (!this.newEquipment.replace(/[\r\n\s]/g, "")) {
        this.$message({
          message: this.$t("global.请输入"),
          type: "error",
        });
        return;
      }
      if (!this.fieldList.includes(this.newEquipment)) {
        this.fieldList.push(this.newEquipment);
        this.addEquipment = false;
        this.form.field.push(this.newEquipment);
        this.newEquipment = "";
      } else {
        this.$message({
          message: this.$t("global.该标签已存在"),
          type: "error",
        });
      }
    },
    submit() {
      const $this = this;
      this.$refs.userForm.validate((valid) => {
        if (valid) {
          const { avatar, field, ...user } = this.form;
          user.field = field.join(",");
          user.nickname = this.peopleMessage.nickname;
          this.$http.post("/api/u/info/basic/save", user).then((response) => {
            if (response.code === "OK") {
              this.$message({
                message: response.message,
                type: "success",
              });
              setTimeout(() => {
                const redirect = decodeURIComponent(
                  location.search.split("redirect=")[1] || "/UpVideo"
                );
                console.log(redirect);
                $this.$router.replace(redirect);
              }, 1000);
              this.$store.dispatch("setPeopleMessage", {
                ...this.peopleMessage,
                ...user,
              });
            }
          });
        }
      });
    },
    handleClose() {
      this.$emit("close");
    },
  },
};
</script>
<style lang="stylus">
.userInfo {
  .el-form-item__label {
    font-size: 16px;
    font-weight: 500;
    color: #333;
    min-width: 120px;
  }

  .el-input__inner, .el-textarea__inner {
    border: 1px solid rgba(224, 224, 224, 1);
    border-radius: 0;
    background: none;
  }

  .personalProfile .el-textarea__inner {
    height: 60px;
    padding: 15px;
    resize: none;
  }

  .el-textarea .el-input__count {
    background: none;
  }
}
</style>
<style lang="stylus" scoped>
.perfect-user-info {
  background: #fff;
  min-height: calc(100vh - 210px);
  margin: 0 auto;
  padding: 50px 355px 120px;

  h4 {
    font-size: 24px;
    font-weight: 500;
    color: rgba(10, 10, 10, 1);
  }

  .el-form {
    padding-top: 45px;
    font-size: 0;

    .gender, .avatar_1 {
      display: inline-block;
      margin-right: 56px;
      width: 290px;
    }

    .gender1 {
      display: inline-block;
      // margin-right: 60px;
      width: 360px;
    }

    .gender2 {
      display: inline-block;
      // margin-right: 60px;
      line-height: 55px;
      height: 55px;
      width: 360px;
      vertical-align: bottom;
    }

    .el-form-item {
      .el-form-item__label {
        font-size: 16px;
        font-weight: 500;
        color: rgba(254, 86, 48, 1);
      }
    }

    .el-form-item__content {
      .country {
        display: inline-block;
      }

      label {
        margin-right: 30px;
      }

      .area {
        display: inline-block;
      }
    }

    .avator-image {
      display: inline-block;
      width: 50px;
      height: 50px;
      border-radius: 25px;
      background-color: #d8d8d8;
      margin: 0 auto 5px;
    }

    .cropcompones {
      font-size: 10px;

      .showtextstyle {
        font-size: 20px;

        .showtop.change {
          display: none;
        }
      }
    }

    .userstyle1 {
      overflow: hidden;
      box-sizing: border-box;

      span {
        display: inline-block;
        float: left;
        height: 30px;
        font-size: 14px;
        color: #666;
        line-height: 30px;
        font-weight: 400;
        padding: 0 12px;
        cursor: pointer;
        margin: 0 10px 10px 0;
        background: rgba(245, 245, 245, 1);
        box-sizing: border-box;

        &.active {
          color: #fff;
          background: rgba(32, 38, 204, 1);
        }
      }
    }
  }

  .clickaddtitle1 {
    display: inline-block;
    float: left;
    height: 30px;
    cursor: pointer;
    text-align: center;
    color: #666;
    font-weight: 400;
    margin: 0 10px 10px 0;
    line-height: 30px;
    font-size: 14px;
    border: 1px solid rgba(224, 224, 224, 1);
    box-sizing: border-box;
    padding: 0 13px;
  }

  .userinfortit1 {
    position: relative;
    float: left;
    width: 150px;
    height: 30px;
    border: 1px solid rgba(32, 38, 204, 0.85);
    box-sizing: border-box;
    font-size: 0;

    input[type='text'] {
      font-size: 14px;
      padding-left: 10px;
      width: 100%;
      height: 100%;
      padding-left: 10px;
      box-sizing: border-box;
      float: left;
    }

    a {
      position: absolute;
      right: 0;
      top: 0;
      width: 50px;
      height: 30px;
      cursor: pointer;
      text-align: center;
      line-height: 30px;
      font-size: 14px;
      background: rgba(32, 38, 204, 0.08);
      font-weight: 500;
      color: rgba(32, 38, 204, 1);
    }
  }

  .dialog-footer {
    text-align: center;
    display: block;
    padding: 20px 0;

    .el-button--primary {
      background: rgba(32, 38, 204, 1);
      color: #fff;
      height: 40px;
      font-size: 18px;
    }
  }
}

.userinfoSubmit {
  width: 144px;
  height: 40px;
  background: rgba(32, 38, 204, 1);
  line-height: 40px;
  text-align: center;
  margin: 0 auto;
  font-size: 16px;
  font-weight: 500;
  color: rgba(255, 255, 255, 1);
  cursor: pointer;
  margin-top: 70px;
}
</style>



// WEBPACK FOOTER //
// src/pages/my/video/PerfectUserInfo.vue